// Three interlocking cogs showing how Assess leads to Engage leads to Change.
// Chunky blocky teeth like the performance management cog picture.
// Sizes, tooth counts, speeds and mesh alignment all follow real gear ratios:
// 8 teeth -> 12 teeth -> 16 teeth, so angular speeds are inverse (12s/18s/24s per rev).

function gearPath(teeth, rRoot, rOuter, offsetDeg = 0) {
  const cx = 150;
  const cy = 150;
  const step = (Math.PI * 2) / teeth;
  const toothW = step * 0.6; // wide chunky teeth
  const gapW = step - toothW;
  const off = (offsetDeg * Math.PI) / 180;
  const pt = (r, a) => `${(cx + r * Math.cos(a)).toFixed(2)} ${(cy + r * Math.sin(a)).toFixed(2)}`;
  let d = "";
  for (let i = 0; i < teeth; i++) {
    const a0 = off + i * step;
    const a1 = a0 + gapW / 2;
    const a2 = a1 + toothW;
    const a3 = a2 + gapW / 2;
    d += `${i === 0 ? "M" : "L"} ${pt(rRoot, a0)} L ${pt(rRoot, a1)} L ${pt(rOuter, a1)} L ${pt(rOuter, a2)} L ${pt(rRoot, a2)} L ${pt(rRoot, a3)} `;
  }
  return d + "Z";
}

const COGS = [
  {
    title: "Assess",
    icon: "/assets/icon-culture-assessment.png",
    teeth: 8,
    rRoot: 60,
    rOuter: 70,
    color: "#005890", // teal
    dur: 12,
    dir: "cw",
    offset: 0, // gap centred at 0° (right), meshes with cog 2's tooth
    cx: 130,
    cy: 160,
    left: "10.34%",
    top: "30%",
    width: "24.14%",
  },
  {
    title: "Engage",
    icon: "/assets/icon-bespoke-workshops.png",
    teeth: 12,
    rRoot: 90,
    rOuter: 104,
    color: "#005890", // teal
    dur: 18,
    dir: "ccw",
    offset: 15, // tooth centred at 180° (left) into cog 1's gap; tooth at 0° (right)
    cx: 280,
    cy: 160,
    left: "30.34%",
    top: "18.67%",
    width: "35.86%",
  },
  {
    title: "Change",
    icon: "/assets/icon-performance-management.png",
    teeth: 16,
    rRoot: 120,
    rOuter: 139,
    color: "#005890", // teal
    dur: 24,
    dir: "cw",
    offset: 0, // gap centred at 180° (left), meshes with cog 2's tooth
    cx: 490,
    cy: 160,
    left: "60.52%",
    top: "7%",
    width: "47.93%",
  },
];

export default function MethodologyCogs() {
  return (
    <div
      data-testid="home-methodology-cogs"
      aria-hidden="true"
      className="relative mx-auto mt-4 w-full max-w-3xl [container-type:inline-size]"
      style={{ aspectRatio: "580 / 300" }}
    >
      {COGS.map((c) => {
        const scale = 140 / c.rOuter;
        const hubR = c.rRoot * scale * 0.6;
        const iconR = c.rRoot * scale * 0.5;
        return (
          <div key={c.title}>
            <div
              data-testid={`home-methodology-cog-${c.title.toLowerCase()}`}
              className="absolute aspect-square"
              style={{ left: c.left, top: c.top, width: c.width }}
            >
              <div
                className="cog-anim absolute inset-0"
                style={{ animation: `cog-spin-${c.dir} ${c.dur}s linear infinite` }}
              >
                <svg viewBox="0 0 300 300" className="h-full w-full drop-shadow-md">
                  <path d={gearPath(c.teeth, c.rRoot * scale, 140, c.offset)} fill={c.color} />
                  <circle cx="150" cy="150" r={hubR} fill="#ffffff" />
                </svg>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <img
                  src={c.icon}
                  alt=""
                  loading="lazy"
                  className="rounded-full object-cover"
                  style={{ width: `${(iconR / 150) * 100}%`, height: `${(iconR / 150) * 100}%` }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
